import React, { useCallback, useEffect, useState } from 'react';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { useLojas } from '../../data/Lojas';
import { CenteredContainer, TableContainer } from './style';
import { Loja } from '../../protocols/Loja';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { CenterTableContent } from '~/pages/Usuario/components/Table/styles';
import { InputRadio } from '~/components/NovosInputs';

type TableProps = {
  form: UseFormReturn<FieldValues, any>;
};

export const Table: React.FC<TableProps> = ({ form }) => {
  const { lojas } = useLojas();

  const [listLojas, setListLojas] = useState<Loja[]>(lojas);

  const { setValue, register } = form;

  useEffect(() => {
    setListLojas(lojas);
    setValue('lojas', lojas);
  }, [lojas]);

  const columns: GridColumns = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'flg_padrao',
      headerName: 'Padrão?',
      width: 85,
      sortable: false,
      align: 'center',
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <CenteredContainer>
              <InputRadio
                value={row.cod_loja}
                name="flg_padrao"
                register={register}
                checked={row.flg_padrao}
                isError={false}
                onChange={() => changeDefault(row.cod_loja)}
              />
            </CenteredContainer>
          </>
        );
      },
    },
    {
      field: 'label',
      headerName: 'Loja',
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: 'flg_lib_financeiro',
      headerName: 'Lib. Financeiro?',
      headerAlign: 'center',
      flex: 1,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <CenterTableContent>
            <input
              type="checkbox"
              checked={row.flg_lib_financeiro}
              disabled={false}
              onChange={() => handleLiberador(row)}
              style={{ accentColor: '#0052cc', cursor: 'pointer' }}
            />
          </CenterTableContent>
        );
      },
    },
    {
      field: 'flg_vendedor',
      headerName: 'Vendedor?',
      headerAlign: 'center',
      flex: 1,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <CenterTableContent>
            <input
              type="checkbox"
              checked={row.flg_vendedor}
              disabled={false}
              onChange={() => handleVendedor(row)}
              style={{ accentColor: '#0052cc', cursor: 'pointer' }}
            />
          </CenterTableContent>
        );
      },
    },
  ];

  const handleLiberador = (row: any) => {
    const newLojas = listLojas.map((loja: Loja) => {
      loja.cod_loja === row.cod_loja &&
        (loja.flg_lib_financeiro = !row.flg_lib_financeiro);
      return loja;
    });
    setValue('lojas', newLojas);
    setListLojas(newLojas);
  };

  const handleVendedor = (row: any) => {
    const newLojas = lojas.map((loja: Loja) => {
      loja.cod_loja === row.cod_loja && (loja.flg_vendedor = !row.flg_vendedor);
      return loja;
    });
    setValue('lojas', newLojas);
    setListLojas(newLojas);
  };

  const changeDefault = useCallback(
    (value: number) => {
      setListLojas((prev) =>
        prev.map((loja) => {
          const isDefault = loja.cod_loja === value;
          return loja.flg_padrao === isDefault
            ? loja
            : { ...loja, flg_padrao: isDefault };
        }),
      );

      setValue('cod_loja', value);
      setValue('flg_padrao', value);
    },
    [setListLojas, setValue],
  );

  return (
    <TableContainer>
      <DataGrid
        rows={listLojas}
        columns={columns}
        pageSize={5}
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado...',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </TableContainer>
  );
};
